import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface DialogData {
  animal: 'panda' | 'unicorn' | 'lion';
}

@Component({
  selector: 'app-validation-dialog-component',
  templateUrl: 'validation-dialog.component.html',
})
export class ValidationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ValidationDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
